export const SOCKET_EVENTS = Object.freeze({
  NEW_MESSAGE: 'new_message',
  MESSAGE_DELETED: 'message_deleted',
  CHAT_MESSAGE_REACTION_UPDATED: 'chat_message_reaction_updated',
  CHAT_ANNOUNCEMENTS_UPDATED: 'chat_announcements_updated',
  MESSAGES_READ: 'messages-read',
  NEW_EVENT_MESSAGE: 'new_event_message',
  EVENT_MESSAGE_DELETED: 'event_message_deleted',
  EVENT_CHAT_MESSAGE_REACTION_UPDATED: 'event_chat_message_reaction_updated',
  EVENT_CHAT_ANNOUNCEMENTS_UPDATED: 'event_chat_announcements_updated',
  READ_UPDATED: 'read_updated',
  REALTIME_NOTIFICATION: 'realtime_notification',
  TIMETABLE_RUNTIME_UPDATE: 'timetable_runtime_update',
  TIMETABLE_PRESENCE_JOIN: 'timetable_presence_join',
  TIMETABLE_PRESENCE_FOCUS: 'timetable_presence_focus',
  TIMETABLE_PRESENCE_LEAVE: 'timetable_presence_leave',
  TIMETABLE_PRESENCE_STATE: 'timetable_presence_state',
  JOIN_ADMINS: 'join_admins',
  JOIN_EVENT: 'join_event',
  JOIN_ARTIST: 'join_artist',
  JOIN_GROUP_CHAT_THREAD: 'join_group_chat_thread',
  LEAVE_GROUP_CHAT_THREAD: 'leave_group_chat_thread',
  NEW_GROUP_CHAT_MESSAGE: 'new_group_chat_message',
  GROUP_CHAT_MESSAGE_DELETED: 'group_chat_message_deleted',
  GROUP_CHAT_MESSAGE_REACTION_UPDATED: 'group_chat_message_reaction_updated',
  GROUP_CHAT_ANNOUNCEMENTS_UPDATED: 'group_chat_announcements_updated',
  GROUP_CHAT_READ_UPDATED: 'group_chat_read_updated',
  GROUP_CHAT_SETTINGS_UPDATED: 'group_chat_settings_updated',
  GROUP_CHAT_MEMBERSHIP_CHANGED: 'group_chat_membership_changed',
  CHAT_LINK_PREVIEW_READY: 'chat_link_preview_ready',
});
